import { render, staticRenderFns } from "./Inventory-Management.vue?vue&type=template&id=89c0bb1c&scoped=true"
import script from "./Inventory-Management.vue?vue&type=script&lang=js"
export * from "./Inventory-Management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c0bb1c",
  null
  
)

export default component.exports